<template>
  <td :colspan="colspan">
    <div class="row sp-details">
      <div 
        v-for="(field, index) in fields" 
        :key="index" 
        class="col-12 mb-4"
      >
        <strong :class="{ 'label-detail': index === 0 }">{{ field.label }}</strong>
        <div class="json-text">
          {{ getFieldValue(item, field.key) }}
          <v-btn
            icon
            small
            class="clipboard-icon"
            @click="copyToClipboard(getFieldValue(item, field.key))"
          >
            <v-icon size="18">mdi-clipboard-multiple</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </td>
</template>

<script>
export default {
  name: 'LogExpandedDetail',
  props: {
    item: {
      type: Object,
      required: true,
    },
    colspan: {
      type: Number,
      required: true,
    },
    fields: {
      type: Array,
      default: () => [
        { label: 'Request Header', key: 'request_header' },
        { label: 'Request Body', key: 'request_raw' },
        { label: 'Response Header', key: 'response_header' },
        { label: 'Response Body', key: 'response_raw' },
        { label: 'Reference', key: 'reference' },
        { label: 'Error Description', key: 'error_description' },
        { label: 'Merchant ID', key: 'merchant_id' },
      ],
    },
  },
  methods: {
    getFieldValue(item, key) {
      if (!item || !key) return '';
      
      // Support nested keys like 'response_raw.data.bill_number'
      const keys = key.split('.');
      let value = item;
      
      keys.forEach((k) => {
        if (value && typeof value === 'object') {
          value = value[k];
        } else {
          value = '';
        }
      });
      
      return value ?? '';
    },
    copyToClipboard(content) {
      const text = typeof content === 'object' ? JSON.stringify(content, null, 2) : content;
      navigator.clipboard.writeText(text);
    },
  },
};
</script>

<style scoped>
.sp-details {
  padding: 10px;
  margin: 10px 0 0 15px;
}

.json-text {
  position: relative;
  background-color: #eeeeee;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.8rem;
  font-weight: bold;
  color: #333333;
  padding: 8px;
  border-radius: 4px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  min-height: 30px;
  word-break: break-all;
}

.clipboard-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  background-color: transparent;
  color: #555;
  transition: color 0.3s;
}

.clipboard-icon:hover {
  color: #000;
}
</style>
